import {
    getBunnyEmbedUrl,
    getBunnyVideoFrameStyle,
    resolveBunnyVideoOrientation,
} from "../utils/utils";

const BunnyVideoEmbed = ({
    videoUrl,
    orientation,
    videoWidth,
    videoHeight,
    variant = "modal",
    isLoading = false,
    onLoad,
    autoplay = false,
    loop = false,
    muted = false,
    preload = true,
    responsive = true,
    allow = "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
    wrapperClassName = "",
    iframeClassName = "",
    loadingOverlayClassName = "absolute inset-0 animate-pulse bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 dark:from-gray-700 dark:via-gray-600 dark:to-gray-700",
    loadingIndicator = null,
    title = "Bunny video player",
}) => {
    const resolvedOrientation = resolveBunnyVideoOrientation({
        orientation,
        width: videoWidth,
        height: videoHeight,
        videoUrl,
    });

    const frameStyle = getBunnyVideoFrameStyle({
        orientation: resolvedOrientation,
        variant,
    });

    return (
        <div
            className={`relative overflow-hidden rounded-xl bg-black ${wrapperClassName}`.trim()}
            style={frameStyle}
        >
            {isLoading && (
                <div className={loadingOverlayClassName}>
                    {loadingIndicator}
                </div>
            )}

            <iframe
                src={getBunnyEmbedUrl(videoUrl, {
                    autoplay,
                    loop,
                    muted,
                    preload,
                    responsive,
                })}
                loading="lazy"
                className={`absolute top-0 left-0 h-full w-full ${iframeClassName}`.trim()}
                style={{ border: 0 }}
                allow={allow}
                allowFullScreen
                title={title}
                onLoad={onLoad}
            ></iframe>
        </div>
    );
};

export default BunnyVideoEmbed;
